module.exports = __webpack_public_path__ + "img/global-connection.01d1d2b5.jpeg";